<template>
  <div class="digital-custom-img">
    <div class="digital-custom-img__select">
      <el-select class="pic-list" size="mini" v-model="selectedIconPath" @change="changePic($event)">
        <el-option class="pic-list-item" v-for="item in privateLoadPic" :key="item.id" :label="item.fileName" :value="item.path">
          {{ item.fileName }}
          <!--          <img class="select-del" src="@imgs/delete-gray.png" @click="delLoadPic(item, $event)" />-->
        </el-option>
      </el-select>
      <span class="upload-btn" @click="uploadImg">上传</span>
      <digital-upload-image
        ref="digitalUploadImage"
        :classifyManage="classifyManage"
        @updateImageState="updateImageState"
        @updateImageSuccess="updateImageSuccess"
        @updateImageComplete="updateImageComplete"
        @updateImageError="updateImageError"
        :file-size="1"
      />
    </div>
    <div class="digital-custom-img__review">
      <div class="digital-custom-img__tip" v-if="!selectedIconPath">
        <div>建议尺寸32*32</div>
        <span>显示效果最佳</span>
      </div>
      <img :src="selectedIconPath" alt="" width="100%" height="100%" v-else />
    </div>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfirm" />
  </div>
</template>

<script>
import DigitalUploadImage from './DigitalUploadImage'
import TipDialog from '@components/common/TipDialog.vue'
import getBook from '@api/getBook'
import { mapState } from 'vuex'

export default {
  name: 'DigitalCustomImg',
  components: {
    TipDialog,
    DigitalUploadImage
  },
  props: {
    editConfig: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('book'),
    classifyManage() {
      return this.$store.state.book.classifyManage
    }
  },
  data() {
    return {
      a: false,
      privateLoadPic: [], //自定义上传图片
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      },
      deletePic: null,
      audioPic: null,
      selectedIconPath: null,
      uploadImageStatus: false,
      picCache: [],
      currentIconObj: {}
    }
  },
  methods: {
    init(type) {
      const params = {
        classifyManage: type
      }
      getBook.getFileAttachListByClassify(params).then((res) => {
        let { data, status } = res.data
        if (status === 0) {
          console.log(this.editConfig)
          this.privateLoadPic = data
          if (this.privateLoadPic.find((_) => _.id == this.editConfig?.btnAttachId)) {
            this.selectedIconPath = this.editConfig?.btnPath
          } else {
            this.selectedIconPath = this.privateLoadPic[0]?.path
          }
          this.changePic(this.selectedIconPath)
        }
      })
    },
    changePic(item) {
      this.currentIconObj = this.privateLoadPic.find((_) => _.path == item) || {}
    },
    updateIcon() {
      this.$emit('update-obj', this.currentIconObj)
    },
    uploadImg() {
      if (this.uploadImageStatus === false) {
        this.$refs.digitalUploadImage.upload()
      } else {
        this.$alert(`正在上传图片中，请稍待`, '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    updateImageState(state) {
      if (state === 'start') {
        this.uploadImageStatus = true
      }
    },
    updateImageSuccess(res) {
      // 回调上传成功
      this.selectedIconPath = res.data.path
      this.privateLoadPic.push(res.data)
      this.changePic(this.selectedIconPath)
      this.$emit('add-icon', res.data.id)
    },
    updateImageComplete() {
      this.uploadImageStatus = false
    },
    updateImageError() {
      // 恢复上传状态
      setTimeout(() => {
        this.uploadImageStatus = false
      }, 100)
    },
    delLoadPic(item) {
      this.deletePic = item.id
      this.$refs.deleteDialog.visible = true
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
      this.deletePic = []
    },
    deleteConfirm() {
      this.picCache.push(this.deletePic)
      this.$emit('del-config', this.picCache.join())
      this.privateLoadPic = this.privateLoadPic.filter((_) => _.id !== this.deletePic).slice()
      this.selectedIconPath = this.privateLoadPic[0]?.path
      this.changePic(this.selectedIconPath)
      this.updateIcon()
      this.deleteCancel()
    }
  }
}
</script>

<style scoped lang="scss">
.digital-custom-img {
  &__select {
    margin: 5px 0;
    .el-select {
      width: 90px;
    }
  }
  &__review {
    width: 122px;
    height: 35px;
    background: #fffaf4;
    color: #000;
    margin-top: 5px;
    &__tip {
      font-size: 14px;
    }
  }
  .upload-btn {
    display: inline-block;
    padding: 4px 15px;
    margin-left: 8px;
    background: #df5813;
    color: #fff;
    border-radius: 15px;
    text-align: center;
    font-size: 14px;
  }
  .pic-list {
    .el-input__inner {
      padding-right: 10px !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
</style>
